import { LOAD_STATE } from './axios.constants';

export const isDataLoading = loadState => (
    LOAD_STATE.LOADING === loadState
);

export const isDataLoadingSucceeded = loadState => (
    LOAD_STATE.SUCCESS === loadState
);

export const getErrorKey = (action) => {
    const { errors } = action.payload.response;
    return errors;
};
